<script>
import { healthVaultService } from '@services/safehaven/HealthVaultService'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    selectedItem: {
      type: null,
      required: false,
      default: {},
    },
    selected: {
      type: null,
      required: false,
      default: null,
    },
    allTags: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      selectedDocument: null,
      selectedTags: [],
      tags: [],
      showTagError: false,
      showsizeError: false,
      fileNameError: false,
      loading: false,
    }
  },
  mounted() {
    this.selectedDocument = this.selected
    this.tags = this.allTags
    const ind = this.tags.findIndex((res) => res.id === 'showall')
    if (ind !== -1) this.tags.splice(ind, 1)
    if (this.selectedItem && this.selectedItem.all_tags_details) {
      this.selectedItem.all_tags_details.map((rec) => {
        this.selectedTags.push(rec)
      })
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
      this.$emit('update:dialog', false)
    },
    validateDocument() {
      if (!this.selectedTags.length) {
        this.showTagError = true
      }
      if (!this.isEdit && this.selectedTags.length) {
        if (
          this.selectedDocument.type === 'application/pdf' ||
          this.selectedDocument.type === 'image/jpeg' ||
          this.selectedDocument.type === 'image/png'
        ) {
          if (this.selectedDocument.size > 31457280) {
            this.showsizeError = true
          } else {
            this.addUpdateDocument()
          }
        } else {
          this.showsizeError = true
        }
      } else if (this.selectedTags.length) {
        this.addUpdateDocument()
      }
    },
    addUpdateDocument() {
      this.loading = true
      if (!this.isEdit) {
        const data = new FormData()
        data.append('document_file', this.selectedDocument)
        const stringifiedTags = JSON.stringify(this.selectedTags)
        data.append('health_vault_tags', JSON.stringify(stringifiedTags))
        healthVaultService.uploadHealthVault(data).then(
          (res) => {
            this.loading = false
            this.closeDialog()
          },
          (err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message === 'File name already exists'
            )
              this.fileNameError = true
            this.loading = false
          }
        )
      } else {
        const document = {
          document_id: this.selectedItem.document_id,
          health_vault_tags: this.selectedTags,
        }
        healthVaultService.updateHealthVault(document).then(
          (res) => {
            this.loading = false
            this.closeDialog()
          },
          (err) => {
            this.loading = false
            console.warn(err.response.data)
          }
        )
      }
    },
  },
}
</script>

<template>
  <div v-if="isEdit ? dialog : selectedDocument && dialog" class="text-center">
    <v-dialog :value="dialog" width="495" persistent>
      <v-card class="pa-4">
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-0"
        ></v-progress-linear>
        <v-icon class="float-right" @click="closeDialog">mdi-close</v-icon>
        <v-card-title>
          <h6>You've selected</h6>
          <h4>{{
            isEdit ? selectedItem.document_name : selectedDocument.name
          }}</h4>
          <h6 v-if="!showsizeError && !fileNameError"
            >Select the tags you’d like to apply to this document</h6
          >
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="mx-auto">
            <v-col
              v-if="!showsizeError && !fileNameError"
              cols="col-10"
              md="10"
              xl="10"
              lg="10"
              sm="10"
              class="mt-6"
            >
              <v-checkbox
                v-for="tag in tags"
                :key="tag.id"
                v-model="selectedTags"
                :label="tag.tag_name"
                :value="tag"
                class="pa-0 ma-0"
                style="display: inline-block; width: 50%"
              ></v-checkbox>
            </v-col>
            <v-col
              v-if="showsizeError"
              cols="col-10"
              md="10"
              xl="10"
              lg="10"
              sm="10"
              :class="$style.error"
            >
              Error uploading file. File type must be either PDF, JPG or PNG
              with a maximum file size of 30MB.</v-col
            >
            <v-col
              v-if="fileNameError"
              cols="col-10"
              md="10"
              xl="10"
              lg="10"
              sm="10"
              :class="$style.error"
            >
              File name already exists</v-col
            >
          </v-row>
        </v-card-text>

        <v-card-actions class="ma-0 py-0">
          <v-btn
            v-if="!showsizeError && !fileNameError"
            class="mx-auto mb-4 primary-btn full-width-btn"
            @click="validateDocument"
          >
            Add to Document Center
          </v-btn>
          <v-btn
            v-if="showsizeError || fileNameError"
            rounded
            class="mx-auto mb-4 mt-2 primary-btn full-width-btn"
            @click="closeDialog"
          >
            OK
          </v-btn>
        </v-card-actions>
        <v-row
          v-if="showTagError && !selectedTags.length"
          class="mx-auto text-center"
        >
          <v-col
            cols="col-12"
            md="12"
            xl="12"
            lg="12"
            sm="12"
            :class="$style.error"
          >
            Please select at least one tag to proceed</v-col
          >
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';

h6 {
  font-size: 14px;
  font-weight: 400;
  color: #454648;
}

h4 {
  width: 100%;
  font-size: 22px;
  font-weight: 600;
  color: #454648;
}

.btnClss {
  width: 100%;
  padding: 1.5rem 1.5rem !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #fff !important;
  text-transform: none;
  background: #0476d9 !important;
  border: none;
  box-shadow: none !important;
}

.error {
  font-size: 14px;
  font-weight: 400;
  color: #ee6363 !important;
}
</style>
